import React, { useRef } from 'react'
import './NumPadToggleBox.component.css'
import NumberPad from '../numberPad/NumberPad.component'
import { IonLabel } from '@ionic/react'

export interface INumPadToggleBox {
  label: string
  score?: string
  unit?: string
  onClickAction?: () => void
  isNumberPadEnabled?: boolean
  action?: (...args: any[]) => any
  numberPadValues?: string[]
  isTemp?: boolean
  unitLabel?: string
  validCharacters?: string[]
  dataTestId?: string
  validationAction?: string
  className?: string
  disabled?: boolean
}

const NumPadToggleBox: React.FC<INumPadToggleBox> = (props: INumPadToggleBox) => {
  const {
    label,
    score,
    unit,
    onClickAction,
    isNumberPadEnabled = true,
    action,
    numberPadValues = [],
    unitLabel = '',
    isTemp = false,
    validCharacters = [],
    dataTestId = '',
    validationAction = '',
    className = '',
    disabled = false,
  } = props
  const numberPadRef: any = useRef(null)

  return (
    <div
      className={`button-container ${className} ${disabled ? 'number-pad-disabled' : ''}`}
      onClick={(e) => {
        if (isNumberPadEnabled) numberPadRef?.current?.showNumberPad(e)
        if (onClickAction) onClickAction()
      }}>
      <div className='numpad-toggle-box-score-unit'>
        <span className='numpad-toggle-box-score'>
          {score ? score : '- -'} {score ? unitLabel : ''}
        </span>
        <span className='numpad-toggle-box-unit'>{unit ? ' ' + unit : ''}</span>
      </div>
      <IonLabel className='numpad-toggle-box-label' color='medium'>
        {label}
      </IonLabel>
      {isNumberPadEnabled && (
        <>
          <NumberPad
            ref={numberPadRef}
            dataTestId='extendedNumberPad'
            fieldHeader={label}
            label={unitLabel}
            values={numberPadValues}
            toggleEnable={isTemp}
            onNumPadClick={(numbersArr: any) => {
              if (action) action([...numbersArr])
            }}
            numberPadExtendedLayout={isNumberPadEnabled}
            validCharacters={validCharacters}
            toggleDataTestId={dataTestId}
            action={validationAction}
          />
        </>
      )}
    </div>
  )
}

export default NumPadToggleBox
